export const getQueryParam = (prop) => {
  const params = {};
  const search = decodeURIComponent(window.location.href.slice(window.location.href.indexOf('?') + 1));
  const definitions = search.split('&');
  definitions.forEach((val) => {
    const parts = val.split('=', 2);
    params[parts[0]] = parts[1];
  });
  return (prop && prop in params) ? params[prop] : params;
};

export const isValidUrl = (text: string): boolean => {
  try {
    const urlPattern = /^(https?:\/\/|www\.)/i;
    return urlPattern.test(text);
  } catch {
    return false;
  }
};